import React from "react";
import "./LoadingSpinner.css";

export default function LoadingSpinner() {
  return (
    <div className="spinner-container h-full w-full flex justify-center items-center bg-white">
      <div className="loading-spinner"></div>
    </div>
  );
}